import $ from 'jquery';
import Cookies from 'js-cookie';

const $cookiesEl = $('.cookies');
const $cookiesBar = $('.cookies__bar');
const cookiesModal = $('#cookies-modal');
const $cookiesConsent = $('.cookies-consent, .cookies-check-all');
const $cookiesConsentCustom = $('.cookies-consent-custom');
const $cookiesDecline = $('.cookies-decline');
const $cookiesTrigger = $('.cookies-trigger');
const $checkboxes = $cookiesEl.find('.cookies__checkbox');
const $cookieName = SITE_PARAMS.cookie_name;
const $cookieId = 'cookie_id';

const cookiesExpiration = 120;

const acknowledgeCookies = (type = 'custom') => {
    let categories = [];

    switch (type) {
        case 'all':
            checkAll();
            break;
        case 'required':
            checkRequired();
            break;
        case 'custom':
            break;
    }

    $checkboxes
        .filter(function () {
            return $(this).is(':checked');
        })
        .each(function () {
            categories.push($(this).data('category'));
        });

    categories = categories.join(',');

    const cookie_cnsnt = Cookies.get($cookieName);

    if (cookie_cnsnt === undefined || cookie_cnsnt != categories) {
        Cookies.set($cookieName, categories, { expires: cookiesExpiration });
        initCookieFunctions();
    }

    const cookie_id = Cookies.get($cookieId);

    if (cookie_id === undefined) {
        Cookies.set($cookieId, generateId(20), { expires: cookiesExpiration });
    }

    // addCookiesSetting(
    //     encodeURIComponent(Cookies.get($cookieId)),
    //     encodeURIComponent(Cookies.get($cookieName))
    // );
};

const initCookieFunctions = () => {
    const cookie_cnsnt = Cookies.get($cookieName);

    if (cookie_cnsnt !== undefined) {
        if (SITE_PARAMS.user_is_admin) {
            console.log('Cookie init...' + cookie_cnsnt);
        }
    }
};

const checkAll = () =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .prop('checked', true);

const checkRequired = () =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .prop('checked', false);

const checkSelected = categories =>
    $checkboxes
        .filter(function () {
            return !$(this).is(':disabled');
        })
        .each(function () {
            const $thisEl = $(this);
            $thisEl.prop('checked', categories.includes($thisEl.data('category')));
        });

Cookies.get($cookieName) === undefined ? $cookiesBar.addClass('cookies__bar--active') : '';

$cookiesConsent.on('click', () => {
    acknowledgeCookies('all');
    $cookiesBar.removeClass('cookies__bar--active');
    updateCookies();
});

$cookiesDecline.on('click', () => {
    acknowledgeCookies('required');
    $cookiesBar.removeClass('cookies__bar--active');
    updateCookies();
});
$cookiesConsentCustom.on('click', () => {
    acknowledgeCookies();
    $cookiesBar.removeClass('cookies__bar--active');
    updateCookies();
});

cookiesModal.on('modal:opening modal:closing', () => {
    const cookie_cnsnt = Cookies.get($cookieName);

    if (cookie_cnsnt !== undefined) {
        const categories = cookie_cnsnt.split(',');
        checkSelected(categories);
    } else {
        checkRequired();
    }
});

const generateId = length => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;

    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }

    return result;
};

function updateCookies()  {
    const options = {
        'ad_storage': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'denied',
        'personalization_storage': 'denied',
        'security_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
    };

    const cookie_cnsnt = Cookies.get($cookieName);
    if (cookie_cnsnt !== undefined) {
        const categories = cookie_cnsnt.split(',');

        for (var i = 0; i < categories.length; i++) {
            if (options[categories[i]] !== undefined) {
                options[categories[i]] = 'granted';
            }
        }
    }

    gtag('consent', 'update', options);
}

// cookies modal behaviour
const $document = $(document);
let $modalTrigger;
const $cookiesClose = $('#cookies-modal-close');

$(function () {
    $document.on('click', '.cookies-modal-close', function () {
        const $targetModal = $(this).closest('.cookies-modal');
        closeModal($targetModal);
    });
    $document.on('click', '.cookies__content > *', function (event) {
        event.stopImmediatePropagation();
    });
    $document.on('click', '.cookies__content', function (event) {
        event.stopImmediatePropagation();
    });
    $document.on('click', '.cookies-trigger', function () {
        const $targetModal = $($(this).data('target'));
        openModal($targetModal);
        $cookiesClose.trigger('focus');
    });
    $cookiesTrigger.on('keydown', function (event) {
        if (event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            $('.cookies-consent').trigger('focus');
        } else if (event.key === 'Tab') {
            event.preventDefault();
            $('.cookies-consent').trigger('focus');
        }
    });
    $document.on('click', '.cookies-modal', function () {
        closeModal($(this));
    });
    $document.on('keydown', function (event) {
        const $targetModal = $document.find('.cookies-modal.active');
        if (event.key === 'Escape') {
            closeModal($targetModal);
        }
    });
    $cookiesClose.on('keydown', function (event) {
        if (event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            $cookiesDecline.trigger('focus');
        }
    });
    $cookiesDecline.on('keydown', function (event) {
        if (event.shiftKey && event.key === 'Tab') {
            event.preventDefault();
            $cookiesConsentCustom.trigger('focus');
        } else if (event.key === 'Tab') {
            event.preventDefault();
            $cookiesClose.trigger('focus');
        }
    });
});

export function openModal(targetModal) {
    if (targetModal !== undefined) {
        if (!targetModal.hasClass('active')) {
            targetModal.trigger('.cookies-modal:opening');
            targetModal.addClass('active').one('transitionend', function () {
                targetModal.trigger('.cookies-modal:opened');
            });
        }
    }
}

export function closeModal(targetModal) {
    if (targetModal !== undefined) {
        if (targetModal.hasClass('active')) {
            targetModal.trigger('cookies-modal:closing');
            targetModal.removeClass('active').one('transitionend', function () {
                targetModal.trigger('cookies-modal:closed');
                $modalTrigger.trigger('focus');
            });
        }
    }
}
